{
  "nl": {
    "partner": {
      "actions": {
        "activate": "Activeren",
        "add": "Voeg toe",
        "changeProfilePicture": "Verander profielfoto",
        "deactivate": "Deactiveren",
        "new": "Partner",
        "profilePictureFormat": "Moet vierkant zijn, minimaal 300x300px",
        "save": "Opslaan",
        "sendinvitation": "Stuur uitnodiging",
        "submit": "Opslaan",
        "undoChanges": "Ongedaan maken"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Een keer per dag (rond het middaguur)",
          "hourly": "Elk uur",
          "twice_daily": "Tweemaal per dag (ochtend/middag)",
          "weekly": "Een keer per week (maandagmiddag)"
        },
        "first_name": "Voornaam",
        "internal_note": "Interne Notitie",
        "language": "Taal",
        "last_name": "Achternaam",
        "phone_landline": "Vast nummer",
        "phone_mobile": "Mobiel nummer",
        "profession": "Jobtitel",
        "session_ended_at": "Bezoek begonnen om",
        "status": "Status",
        "title": "Titel"
      },
      "labels": {
        "activate_message": "{name} krijgt opnieuw toegang tot het platform.",
        "addExistingCompany": "Voeg toe aan bestaande organisatie",
        "contactDetails": "Contactgegevens",
        "createNewCompany": "Maak nieuwe organisatie aan",
        "deactivate_message": "{name} behoudt het account, maar verliest toegang tot het platform. Berichten, documenten en de naam blijven beschikbaar.",
        "information": "Profielinformatie",
        "newTeamMember": "Nieuw teamlid",
        "notEditable": "Bepaalde velden kunnen niet meer bewerkt worden bij een actieve partner",
        "partnerAddedState": "<b>Nog niet uitgenodigd.</b> Er wordt een uitnodigingsmail verzonden zodra {partner_name} toegang krijgt tot een gepubliceerde beslissing, punt of document.",
        "selectedCompany": "Geselecteerde organisatie",
        "start_by_selecting_project": "Begin met het selecteren van een project aan de linkerkant"
      },
      "toasts": {
        "create": "Partner aangemaakt",
        "update": "Partner gewijzigd"
      },
      "validation": {
        "mustBeEmailAddress": "Moet een emailadres zijn",
        "needFirstName": "Voornaam is vereist",
        "needLastName": "Achternaam is vereist",
        "requireEmailAddress": "Emailadres vereist"
      }
    }
  }
}
